import React,{useContext} from "react";
import { Link, useLocation } from "react-router-dom";
import { BiUser } from "react-icons/bi";
import { TbBrandAsana, TbFileInvoice,TbTruckReturn } from "react-icons/tb";
import { BiCategory } from "react-icons/bi";
import { SiApostrophe } from "react-icons/si";
import { HiOutlineUserGroup } from "react-icons/hi";
import { FiShoppingCart } from "react-icons/fi";
import { MdOutlineAnalytics, MdPets } from "react-icons/md";
import { RiBuildingLine ,RiDeleteBin3Line,RiFileList3Line} from "react-icons/ri";
import { AiOutlinePound, AiOutlineDeploymentUnit } from "react-icons/ai";
import { IoStorefrontOutline, IoWarningOutline } from "react-icons/io5";
import { GiBrokenPottery } from "react-icons/gi";
import { ImBarcode } from "react-icons/im";
import { IoMdReturnLeft, IoMdClose } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { GoLaw } from "react-icons/go";
import { GlobalContext } from "../context/provider";
import './css/onprintcss.css'

const Menu = ({hide_menu,sethide_menu}) => {
  const location = useLocation();
  const {initState}=useContext(GlobalContext);

  const MenuItem = ({to, icon: Icon, label, isActive}) => (
    <Link
      to={to}
      onClick={() => {sethide_menu(true);}}
      className="block"
    >
      <div className={
        isActive
          ? "mx-3 px-3 h-10 rounded-lg flex items-center gap-3 bg-indigo-50 text-indigo-600 transition-all duration-150"
          : "mx-3 px-3 h-10 rounded-lg flex items-center gap-3 text-slate-500 hover:bg-slate-50 hover:text-slate-800 transition-all duration-150 cursor-pointer"
      }>
        <Icon size={18} />
        <span className={isActive ? "text-base font-semibold" : "text-base font-medium"}>{label}</span>
      </div>
    </Link>
  );

  const SectionLabel = ({name}) => (
    <p className="px-4 pt-5 pb-1 text-[10px] font-semibold uppercase tracking-widest text-slate-400">
      {name}
    </p>
  );

  const SectionDivider = () => (
    <div className="mx-4 border-t border-slate-100 mt-3" />
  );

  return (
    <div className="print_hide max-h-[100vh] overflow-y-auto pb-8 z-40 bg-white border-l border-slate-100 w-72">
      <div className="absolute left-2 top-3 md:hidden">
        <IoMdClose size={30} className="cursor-pointer" onClick={() => { sethide_menu(true); }} />
      </div>
      
      {/* Logo Area */}
      <div className="flex items-center gap-2 px-5 py-6 mb-2">
        {/* <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center">
          <span className="text-white text-sm font-bold">HS</span>
        </div> */}
        <span className="font-semibold text-slate-800 text-lg">SSKM</span>
      </div>

      <div className="w-full">
        <div className="mt-3">
        <div>
          {/* PEOPLE GROUP */}
          <SectionLabel name="NOTIFICATIONS" />
          <MenuItem
            to="/"
            icon={IoWarningOutline}
            label="نزیک لە بەسەرچوون"
            isActive={location.pathname == "/"}
          />

          <SectionDivider />
          
          {/* SALES GROUP */}
          <SectionLabel name="SALES" />
          <MenuItem
            to="/sell"
            icon={FiShoppingCart}
            label="فرۆشتن"
            isActive={location.pathname == "/sell"}
          />
          <MenuItem
            to="/returnbybarcode"
            icon={IoMdReturnLeft}
            label="گەڕانەوە بە باڕکۆد"
            isActive={location.pathname == "/returnbybarcode"}
          />

          <SectionDivider />

          {/* PEOPLE GROUP */}
          <SectionLabel name="CONTACTS" />
          <MenuItem
            to="/company"
            icon={RiBuildingLine}
            label="کۆمپانیا"
            isActive={location.pathname == "/company"}
          />
          <MenuItem
            to="/customer"
            icon={BiUser}
            label="کڕیار"
            isActive={location.pathname == "/customer"}
          />

          <SectionDivider />

          {/* INVENTORY GROUP */}
          <SectionLabel name="INVENTORY" />
          <MenuItem
            to="/category"
            icon={BiCategory}
            label="کاتیگۆری"
            isActive={location.pathname == "/category"}
          />
          <MenuItem
            to="/item"
            icon={TbBrandAsana}
            label="کاڵا"
            isActive={location.pathname == "/item"}
          />
          <MenuItem
            to="/service"
            icon={MdPets}
            label="خزمەتگوزاری"
            isActive={location.pathname == "/service"}
          />
          <MenuItem
            to="/removeditem"
            icon={RiDeleteBin3Line}
            label="لیستی کاڵای سڕاوە"
            isActive={location.pathname == "/removeditem"}
          />
          <MenuItem
            to="/broke"
            icon={GiBrokenPottery}
            label="خەسار"
            isActive={location.pathname == "/broke"}
          />
          <SectionDivider />

          {/* INVENTORY GROUP */}
          <SectionLabel name="Buy" />
          <MenuItem
            to="/buy"
            icon={IoStorefrontOutline}
            label="کڕین"
            isActive={location.pathname == "/buy"}
          />
          <MenuItem
            to="/buyinvoice"
            icon={TbFileInvoice}
            label="وەسڵی کڕاو"
            isActive={location.pathname == "/buyinvoice"}
          />
          <MenuItem
            to="/returnitemtocompany"
            icon={TbTruckReturn}
            label="گەڕانەوەی کاڵا بۆ کۆمپانیا"
            isActive={location.pathname == "/returnitemtocompany"}
          />

          <SectionDivider />

          {/* FINANCE GROUP */}
          <SectionLabel name="FINANCE" />
          <MenuItem
            to="/expensetype"
            icon={SiApostrophe}
            label="جۆری خەرجی"
            isActive={location.pathname == "/expensetype"}
          />
          <MenuItem
            to="/expense"
            icon={AiOutlinePound}
            label="خەرجی"
            isActive={location.pathname == "/expense"}
          />
          {initState.token.role=='admin'?
          <MenuItem
            to="/report"
            icon={MdOutlineAnalytics}
            label="ڕاپۆرت"
            isActive={location.pathname == "/report"}
          />:null}

          <SectionDivider />

          {/* TOOLS GROUP */}
          <SectionLabel name="TOOLS" />
          <MenuItem
            to="/barcode"
            icon={ImBarcode}
            label="باڕکۆد پرینتەر"
            isActive={location.pathname == "/barcode"}
          />

          <SectionDivider />

          {initState.token.role=='admin'?<>
          <SectionLabel name="ADMIN" />
          <MenuItem
            to="/user"
            icon={HiOutlineUserGroup}
            label="بەکارهێنەر"
            isActive={location.pathname == "/user"}
          /></>:null}
        </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
